import { BaseComponent } from '../base-component'
import { delay, $el } from '../../utils/utils'
import { ClipboardButtonTooltip } from './clipboard-button-tooltip'

export class ClipboardButton extends BaseComponent {
  mountComponent(): void {
    this.addListener(this, 'click', this.handleButtonClick)
  }

  handleButtonClick = (event: MouseEvent): void => {
    event.preventDefault()
    this.copy()
  }

  copy = (): void => {
    const value = this.dataset.value

    if (value && navigator.clipboard) {
      navigator.clipboard
        .writeText(value)
        .then(() => {
          this.showTooltip()
        })
        .catch(e => {
          if (window.Shopify.designMode) {
            // The Clipboard API blocked in Shopify editor
            this.showTooltip()
          }
          throw e
        })
    }
  }

  showTooltip(): void {
    const tooltip: ClipboardButtonTooltip = $el(`#${this.dataset.tooltipId}`)

    if (tooltip) {
      tooltip.show()

      delay(1000).then(() => {
        tooltip.hide()
      })
    }
  }
}
